<template>
    <div>
        <div class="form-group">
            <label>Endpoint</label>
            <input type="text" class="form-control" v-model="data.endpoint">
        </div>
        <div class="form-group">
            <label>JobBoard ID</label>
            <input type="text" class="form-control" v-model="data.jobboardId">
        </div>
        <div class="form-group">
            <label>Tenant ID</label>
            <input type="text" class="form-control" v-model="data.tenantId">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>